import { MasterBrand } from '../models/models';

export interface MasterBrandLike {
  id: number | string;
  name: string;
}

export const formatMasterBrandLabel = (brand: MasterBrandLike | null | undefined): string => {
  if (!brand || brand.name == null) {
    return '';
  }
  return `${brand.name} (${brand.id})`;
};

export const isSameMasterBrand = (
  option: MasterBrandLike | null | undefined,
  value: MasterBrandLike | null | undefined,
): boolean => {
  if (!option || !value) {
    return false;
  }
  return option.id === value.id;
};

export const normalizeMasterBrandValue = (
  brand: MasterBrand | null | undefined,
): MasterBrand | null => {
  if (!brand || typeof brand !== 'object') {
    return null;
  }
  return brand;
};
